import { render, staticRenderFns } from "./card-compare-sowhatbuy.vue?vue&type=template&id=3319327e&scoped=true&"
import script from "./card-compare-sowhatbuy.vue?vue&type=script&lang=js&"
export * from "./card-compare-sowhatbuy.vue?vue&type=script&lang=js&"
import style0 from "./card-compare-sowhatbuy.vue?vue&type=style&index=0&id=3319327e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3319327e",
  null
  
)

export default component.exports